module.exports = {"CAN":"Canada","USA":"United States"}


//////////////////
// WEBPACK FOOTER
// ./src/config/countries.json
// module id = 1256
// module chunks = 1